import { render } from "./UeStudentsListView.vue?vue&type=template&id=38718a7f&scoped=true"
import script from "./UeStudentsListView.vue?vue&type=script&lang=js"
export * from "./UeStudentsListView.vue?vue&type=script&lang=js"

import "./UeStudentsListView.vue?vue&type=style&index=0&id=38718a7f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38718a7f"]])

export default __exports__